export default __webpack_public_path__ + "static/media/icon-em-pill-clock.839a4082.svg";